export default "__VITE_ASSET__D4WbbR45__"